import api from './api';

export const getPurchaseSiteMigrationSummary = async () => {
  const response = await api.get('/compras/purchase-site-migration/summary');
  return response.data;
};

export const getPurchaseSiteMigrationPending = async (params = {}) => {
  const response = await api.get('/compras/purchase-site-migration/pending', { params });
  return response.data;
};

export const getPurchaseSiteMigrationFilterOptions = async (params = {}) => {
  const response = await api.get('/compras/purchase-site-migration/filter-options', { params });
  return response.data;
};

export const getPurchaseSiteMigrationPendingIds = async (params = {}) => {
  const response = await api.get('/compras/purchase-site-migration/pending-ids', { params });
  return response.data;
};

export const bulkAssignPurchaseSite = async (payload) => {
  const response = await api.post('/compras/purchase-site-migration/bulk-assign', payload);
  return response.data;
};
